import { animateTo } from '../../shared/helpers';

export default class extends Controller {

  connect() {
    App.Helpers.listenToCustomEvent(document, 'update-success', this.respondToModalFormSubmit.bind(this))
    App.Helpers.listenToCustomEvent(document, 'tab-load-success', this.showcasePerson.bind(this));
  }

  respondToModalFormSubmit(event) {
    if (event.detail.type) this.openAffectedTab(event.detail.type);
    this.personID = event.detail.id;
  }

  openAffectedTab(type) {
    document.querySelector(`[data-tab-id="${type}"]`).click();
  }

  showcasePerson() {
    if (this.personRecord) {
      animateTo(this.personRecord);
      this.highlightPerson(this.personRecord);
      this.personID = null;
    }
  }

  highlightPerson(personRecord) {
    personRecord.style.backgroundColor = '#edebe5';
  }

  //
  // GETTERS AND SETTERS
  //

  get personRecord() {
    return this.element.querySelector(`[data-record-id="${this.personID}"]`);
  }

  get personID() {
    return this._personID;
  }

  set personID(id) {
    this._personID = id;
  }
};



// WEBPACK FOOTER //
// ./app/javascript/stimulusControllers/people/people-index-controller.js